import {
  AreaChart as RechartsAreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

import classnames from 'classnames';
import { formatCurrency, formatNumber } from 'components/BarChart';

type formatterType = 'currency' | 'number';

interface AreaChartProps {
  data: AreaChartData[];
  className?: string;
  title?: string;
  subtitle?: string;
  type: formatterType;
}
type AreaChartData = {
  name: string;
  total: number | string;
  value: number | string;
};

const AreaChart = ({
  data,
  className,
  title,
  subtitle,
  type
}: AreaChartProps) => (
  <div className={classnames('rounded-lg border border-[#EBEBEB]', className)}>
    {title && (
      <p className="pl-7 pr-7 pt-4 pb-2 text-[#575757] text-sm font-bold">
        {title}
      </p>
    )}
    {subtitle && (
      <p className="pl-7 pr-7 pb-2 text-[#575757] text-2xl font-black uppercase mb-4">
        {subtitle}
      </p>
    )}
    <ResponsiveContainer width="98%" height={300}>
      <RechartsAreaChart
        data={data}
        margin={{
          top: 10,
          right: 0,
          left: 0,
          bottom: 20
        }}
      >
        <CartesianGrid strokeDasharray="3 3" horizontal vertical={false} />

        <XAxis
          dataKey="total"
          axisLine={false}
          tickLine={false}
          padding={{ left: 10, right: 2 }}
          tick={<CustomTick />}
          tickMargin={10}
          // this prevents the x axis from being cut off if the text is too long
          interval="preserveStartEnd"
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          padding={{ top: 0, bottom: 0 }}
          tick={<CustomTick />}
        />

        <Tooltip
          contentStyle={{
            backgroundColor: '#fff',
            borderRadius: '10px',
            border: '1px solid #EBEBEB'
          }}
          itemStyle={{ color: '#575757' }}
          formatter={(value) => [`${formatCurrency(value, type)}`, 'Revenue']}
        />
        <Area
          type="linear"
          dataKey="value"
          stroke="#6585FF"
          strokeWidth={4}
          fill="#6585FF"
          fillOpacity={0.1}
        />
      </RechartsAreaChart>
    </ResponsiveContainer>
  </div>
);
const CustomTick = (props) => {
  const { x, y, payload } = props;
  const value = String(payload.value); // Ensure the value is a string
  const words = value.split(' '); // Split the text into words

  // Determine the two lines
  const firstLine = words[0]; // First word
  const secondLine = words.slice(1).join(' '); // Remaining words

  return (
    <text
      x={x}
      y={y}
      dy={16}
      textAnchor="middle"
      className="text-center text-[10px] font-normal pt-8"
      style={{ fill: '#838383' }}
    >
      <tspan x={x} dy={0}>
        {isNaN(Number(payload.value))
          ? firstLine
          : formatNumber(Number(payload.value))}
      </tspan>
      <tspan x={x} dy={12}>
        {secondLine}
      </tspan>
    </text>
  );
};
export default AreaChart;
